import LayoutPage from "@/views/Layout/LayoutPage.vue";
import NewLayoutPage from "@/views/NewLayout/LayoutPage.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import ResumeClinic from "@/views/ResumeClinic.vue";

Vue.use(VueRouter);


const routes = [
  {
    path: "/",
    component: NewLayoutPage,

    children: [
      {
        path: "/",
        name: "NewHomePage",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "Home",
          description:
            "Welcome to our homepage where you can explore our services and offerings.",
        },
      },
      {
        path: "/register",
        name: "Register",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "Register",
          description:
            "Register for a free account on Hire3x.",
        },
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "Login",
          description:
            "Log in to your account on Hire3x.",
        },
      },
      {
        path: "/resume_builder",
        name: "ResumeBuilder",
        component: () => import("../views/Home.vue"),
        meta: {
          title: "Resume Builder",
          description:
            "Build your ATS-friendly resume on Hire3x.",
        },
      },
    ],
  },
  {
    path: "/",
    component: LayoutPage,

    children: [
      {
        path: "/home",
        name: "HomePage",
        component: () => import("../views/HomePage.vue"),
        meta: {
          title: "Home",
          description:
            "Welcome to our homepage where you can explore our services and offerings.",
        },
      },
      {
        path: "contactus",
        name: "ContactUs",
        component: () => import("../views/ContactUs.vue"),
        meta: {
          title: "Contact Us",
          description: "Get in touch with our support or sales team.",
        },
      },
      {
        path: "requestdemo",
        name: "RequestDemo",
        component: () => import("../views/RequestDemo.vue"),
        meta: {
          title: "Request a Demo",
          description: "Request a live demo of our product.",
        },
      },
      {
        path: "creator",
        name: "BecomeInstructor",
        component: () => import("../views/BecomeInstructor.vue"),
        meta: {
          title: "Become an Instructor",
          description: "Join us as an expert instructor and help others learn.",
        },
      },
      {
        path: "/builderpage",
        name: "BuilderPage",
        component: () => import("../views/BuilderPage.vue"),
        meta: {
          title: "Builder Page",
          description: "Build and customize your content easily.",
        },
      },
      {
        path: "/assessmentpage",
        name: "AssessmentPage",
        component: () => import("../views/AssessmentPage.vue"),
        meta: {
          title: "Assessment Page",
          description: "Take assessments to evaluate your skills.",
        },
      },
      {
        path: "/termsandconditions",
        name: "TermsAndConditions",
        component: () => import("../views/TermsAndConditions.vue"),
        meta: {
          title: "Terms and Conditions",
          description: "Read the terms and conditions of using our platform.",
        },
      },
      {
        path: "/privacypolicy",
        name: "PrivacyPolicy",
        component: () => import("../views/PrivacyPolicy.vue"),
        meta: {
          title: "Privacy Policy",
          description: "Understand how we handle your data.",
        },
      },
      {
        path: "/trustandsafety",
        name: "TrustAndSafety",
        component: () => import("../views/TrustAndSafety.vue"),
        meta: {
          title: "Trust and Safety",
          description: "Learn about our trust and safety policies.",
        },
      },
      {
        path: "/troubleshooting",
        name: "TroubleShooting",
        component: () => import("../views/TroubleShooting.vue"),
        meta: {
          title: "Troubleshooting",
          description: "Fix common issues and errors with our service.",
        },
      },
      {
        path: "/paymentsandrefunds",
        name: "PaymentsAndRefunds",
        component: () => import("../views/PaymentsAndRefunds.vue"),
        meta: {
          title: "Payments & Refunds",
          description: "Our payment and refund policies explained.",
        },
      },
      {
        path: "/usermanual",
        name: "UserManual",
        component: () => import("../views/UserManual.vue"),
        meta: {
          title: "User Manual",
          description: "Detailed manual to help users navigate the platform.",
        },
      },
      {
        path: "/recruitment",
        name: "Recruitment",
        component: () => import("../views/RecruitmentPage.vue"),
        meta: {
          title: "Recruitment",
          description: "Explore open roles and recruitment details.",
        },
      },
      {
        path: "/careers",
        name: "Careers",
        component: () => import("../views/CareerPage.vue"),
        meta: {
          title: "Careers",
          description: "Join our team and build a great career.",
        },
      },
      {
        path: "/panelistpage",
        name: "PanelistPage",
        component: () => import("../views/PanelistPage.vue"),
        meta: {
          title: "Panelist Page",
          description: "Details for interview panelists.",
        },
      },
      {
        path: "/redirect_campaign/:no/:uuid",
        name: "LoadingPage",
        component: () => import("@/components/commonComponents/LoaderPage.vue"),
        meta: {
          title: "Redirect Campaign",
          description: "Redirect Campaign.",
        },
      },
    ],
  },
  {
    path: "/resumeclinic",
    component: ResumeClinic,
    children: [
      {
        path: "", // Use empty string for the child route to match the parent path
        name: "ResumeClinic",
        component: () => import("../views/ResumeClinic.vue"),
        meta: {
          title: "Resume Clinic",
          description: "Enhance your resume with expert guidance.",
        },
      },
    ],
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "history", // require service support
    routes: routes,
    // scrollBehavior: () => ({ y: 0 }),
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }

      if (localStorage.getItem("scrollToFooter") === "true") {
        localStorage.removeItem("scrollToFooter");
        return {
          selector: "#footer",
          behavior: "smooth",
        };
      }

      return { x: 0, y: 0 };
    },
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;

// To avoid Duplicate Navigation
const onError = (e) => {
  // avoid NavigationDuplicated
  if (e.name !== "NavigationDuplicated") throw e;
};

// Store the original push method
const originalPush = router.push;

// Override the push method
router.push = function push(...args) {
  // Your custom logic here

  try {
    // Call the original push method and handle promises
    const op = originalPush.call(this, ...args);
    if (op instanceof Promise) op.catch(onError);
    return op;
  } catch (e) {
    // Handle errors
    onError(e);
  }
};

// router.afterEach((to) => {
//   if (to.meta?.title) document.title = to.meta.title;

//   if (to.meta?.description) {
//     let tag = document.querySelector('meta[name="description"]');
//     if (tag) {
//       tag.setAttribute("content", to.meta.description);
//     } else {
//       tag = document.createElement("meta");
//       tag.name = "description";
//       tag.content = to.meta.description;
//       document.head.appendChild(tag);
//     }
//   }
// });
